// Class: starling.filters.ColorMatrixEffect

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_rendering_FilterEffect() {return require("./../../starling/rendering/FilterEffect");}
function starling_rendering_Program() {return require("./../../starling/rendering/Program");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_ArgumentError() {return $import(require("openfl/errors/ArgumentError"));}

// Constructor

var ColorMatrixEffect = function() {
	(starling_rendering_FilterEffect().default).call(this);
	this._userMatrix = (openfl__$Vector_Vector_$Impl_$().default)._new();
	this._shaderMatrix = (openfl__$Vector_Vector_$Impl_$().default)._new();
	this.set_matrix(null);
}

// Meta

ColorMatrixEffect.__name__ = "starling.filters.ColorMatrixEffect";
ColorMatrixEffect.__isInterface__ = false;
ColorMatrixEffect.__super__ = (starling_rendering_FilterEffect().default);
ColorMatrixEffect.prototype = $extend((starling_rendering_FilterEffect().default).prototype, {
	createProgram: function() {
		var vertexShader = (starling_rendering_FilterEffect().default).STD_VERTEX_SHADER;
		var fragmentShader = [(starling_rendering_FilterEffect().default).tex("ft0","v0",0,this.get_texture()),"max ft0, ft0, fc5              ","div ft0.xyz, ft0.xyz, ft0.www  ","m44 ft0, ft0, fc0              ","add ft0, ft0, fc4              ","mul ft0.xyz, ft0.xyz, ft0.www  ","mov oc, ft0                    "].join("\n");
		return (starling_rendering_Program().default).fromSource(vertexShader,fragmentShader);
	},
	beforeDraw: function(context) {
		(starling_rendering_FilterEffect().default).prototype.beforeDraw.call(this,context);
		context.setProgramConstantsFromVector("fragment",0,this._shaderMatrix);
		context.setProgramConstantsFromVector("fragment",5,ColorMatrixEffect.MIN_COLOR);
	},
	reset: function() {
		this.set_matrix(null);
	},
	concat: function(matrix) {
		var i = 0;
		var _g = 0;
		while(_g < 4) {
			var y = _g++;
			var _g1 = 0;
			while(_g1 < 5) {
				var x = _g1++;
				(openfl__$Vector_Vector_$Impl_$().default).set(ColorMatrixEffect.sMatrix,i + x,matrix[i] * this._userMatrix[x] + matrix[i + 1] * this._userMatrix[x + 5] + matrix[i + 2] * this._userMatrix[x + 10] + matrix[i + 3] * this._userMatrix[x + 15] + (x == 4 ? matrix[i + 4] : 0));
			}
			i += 5;
		}
		this.copyMatrix(ColorMatrixEffect.sMatrix,this._userMatrix);
		this.updateShaderMatrix();
	},
	copyMatrix: function(from,to) {
		(openfl__$Vector_Vector_$Impl_$().default).set(to,0,from[0]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,1,from[1]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,2,from[2]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,3,from[3]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,4,from[4]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,5,from[5]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,6,from[6]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,7,from[7]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,8,from[8]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,9,from[9]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,10,from[10]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,11,from[11]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,12,from[12]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,13,from[13]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,14,from[14]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,15,from[15]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,16,from[16]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,17,from[17]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,18,from[18]);
		(openfl__$Vector_Vector_$Impl_$().default).set(to,19,from[19]);
	},
	updateShaderMatrix: function() {
		this._shaderMatrix.length = 0;
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[0]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[1]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[2]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[3]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[5]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[6]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[7]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[8]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[10]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[11]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[12]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[13]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[15]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[16]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[17]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[18]);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[4] / 255.0);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[9] / 255.0);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[14] / 255.0);
		(openfl__$Vector_Vector_$Impl_$().default).push(this._shaderMatrix,this._userMatrix[19] / 255.0);
	},
	get_matrix: function() {
		return this._userMatrix;
	},
	set_matrix: function(value) {
		if(value != null && value.length != 20) {
			throw new (js__$Boot_HaxeError().default)(new (openfl_errors_ArgumentError().default)("Invalid matrix length: must be 20"));
		}
		if(value == null) {
			this._userMatrix.length = 0;
			var _g = 0;
			var _g1 = ColorMatrixEffect.IDENTITY;
			while(_g < _g1.length) {
				var val = _g1[_g];
				++_g;
				(openfl__$Vector_Vector_$Impl_$().default).push(this._userMatrix,val);
			}
		} else {
			this.copyMatrix(value,this._userMatrix);
		}
		this.updateShaderMatrix();
		return value;
	}
});
ColorMatrixEffect.prototype.__class__ = ColorMatrixEffect.prototype.constructor = $hxClasses["starling.filters.ColorMatrixEffect"] = ColorMatrixEffect;

// Init

Object.defineProperties(ColorMatrixEffect.prototype,{ matrix : { get : function () { return this.get_matrix (); }, set : function (v) { return this.set_matrix (v); }}});

// Statics


ColorMatrixEffect.MIN_COLOR = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0,0,0,0.0001])
ColorMatrixEffect.IDENTITY = [1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0]
ColorMatrixEffect.sMatrix = (openfl__$Vector_Vector_$Impl_$().default)._new(20,true)

// Export

exports.default = ColorMatrixEffect;